import React from 'react';
import SubmitQuestion from './SubmitQuestion';
import { initReactApp } from 'shared/util/ApplicationInit';

const render = initReactApp(() => <SubmitQuestion />, 'faq-submit-question');

render();

// optional, use this to enable hot reloading
if ((module as any).hot) {
	(module as any).hot.accept('./SubmitQuestion', () => {
		render();
	});
}
